type LoginHomeMap = { [key: string]: string };
type BrandMap = { [key: string]: string };
const env_config = (window as any)?.config;

export const environment = {
  production: env_config?.production || false,
  apiBaseUrl: env_config?.apiBaseUrl || 'https://api.dev.cardinalhealth.net/nphs/smp-experience/v1/api',
  sonexusRedirectPublicKey: env_config?.sonexusRedirectPublicKey || '',
  loginAppBaseUrl: env_config?.loginAppBaseUrl || 'https://nphs-comm-smp-login-web.dev.web.ent.gke.gcp.cahcloud.net',
  jwtForOktab2bUrl: env_config?.jwtForOktab2bUrl || 'https://api.dev.cardinalhealth.com/oauth2/v3/token/jwtforoktab2b',
  userId: '1001',
  manufacturerId: '99000',
  manufacturerCustShipToXrefId: '102000',
  oktaIssuer: 'https://myidb2bdev.cardinalhealth.com/oauth2/default',
  oktaClientId: '0oa2j1sr5sag5NAx70h8',
  oktaDomain: 'https://myidb2bdev.cardinalhealth.com',
  logoutUrl: env_config?.logoutUrl || 'https://api.dev.cardinalhealth.net/nphs/smp-login/v1/api/user/logout',
  webOrderingBaseUrl: env_config?.webOrderingBaseUrl || 'https://api.dev.cardinalhealth.com/nphs/nuctrac-utility',
  loginWebUrl: env_config?.loginWebUrl || 'http://localhost:4200/login',
  wsBrokerUrl: env_config?.wsBrokerUrl || 'wss://api.dev.cardinalhealth.net/nphs/smp-experience/v1/ws',
  inactivityTimeoutMs: 20 * 60 * 1000, // 20 minutes
  LOGIN_HOME_MAP: env_config?.LOGIN_HOME_MAP as LoginHomeMap || {
    itm: 'http://localhost:4200/itm/login',
    cah: 'http://localhost:4200/cah/login'
  } as LoginHomeMap,
  BRAND_MAP: env_config?.BRAND_MAP as BrandMap || {
    'http://localhost:4202': 'itm',
    'http://localhost:4203': 'cah'
  } as BrandMap
};
